import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

const ContentModalSuccess: React.FC = () => {
  return (
    <TextStyled >
      All specified accounts have been updated and verified in accordance with
      our system's requirements
    </TextStyled>
  );
};

export default ContentModalSuccess
